module.exports = __webpack_public_path__ + "img/minb.a4f3048a.png";